import { memo } from 'react'
import { Typography } from '@mui/material'
import tw from 'twin.macro'

const OptionalStepLabelComponent = () => {
  return (
    <div css={tw`rounded bg-info-200 px-1 mb-2 w-fit`}>
      <Typography variant="overline" css={tw`text-info-500`}>
        OPTIONAL STEP
      </Typography>
    </div>
  )
}

export const OptionalStepLabel = memo(OptionalStepLabelComponent)
